import { createSelector } from 'reselect';
import { selectIsXPBCompany } from 'modules/loggedUserInfo/selectors';

export const selectCompanyUnaddedRewards = (state) =>
  state.rewardsReducer?.companyUnaddedRewards;

export const selectCompanyRewardsStatus = (state) =>
  state.rewardsReducer?.status;

export const selectCompanyRewardsFamiliesRaw = (state) =>
  state.rewardsReducer?.companyRewardsFamilies;

export const selectCompanyRewardsFamilies = (state) =>
  selectCompanyRewardsFamiliesRaw(state);

export const selectFamilyData = (state) => state.rewardsReducer?.familyData;

export const selectChosenFamilyTabId = (state) => selectFamilyData(state)?.id;

export const selectFamilyMessage = (state) =>
  state.rewardsReducer?.familyMessage;

export const selectAvailableRewardsOptions = createSelector(
  [selectCompanyUnaddedRewards, selectIsXPBCompany],
  (rewards, isXPB) => {
    if (rewards && rewards.length) {
      return rewards
        .filter((el) => (isXPB && el.tool === 'XPB') || !isXPB)
        .map(({ name, id, code }) => ({
          label: `${name} - ${code}`,
          value: id,
        }));
    }

    return [];
  }
);

export const selectFamilyRewardsMapped = createSelector(
  [selectFamilyData],
  (familyData) => {
    if (familyData && familyData.companyRewards) {
      return familyData.companyRewards.map((rewardData) => ({
        ...rewardData,
        reward: {
          ...rewardData.reward,
          name: rewardData?.reward?.name || rewardData?.customName,
          type: rewardData?.reward?.type || rewardData?.customType,
        },
      }));
    }

    return [];
  }
);

export const selectLastSyncTimeRewards = (state) =>
  state.rewardsReducer?.lastSyncTimeRewards;

export const selectLastSyncingStatusRewards = (state) =>
  state.rewardsReducer?.lastSyncingStatusRewards;
